<div class="image-banner">
	<div class="container-fluid">
		<h1 class="d-none d-md-block">
			Connect <br />
			Case Center
		</h1>
	</div>
</div>
